<app-header [sidebar]="sidebar"></app-header>
<div class="container-lg">
  <div class="row">
    <app-sidebar class="col-lg-3 d-none d-lg-block" #sidebar></app-sidebar>
    <div class="col-lg-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
